import { render, staticRenderFns } from "./HsabBiometricAuthSetup.vue?vue&type=template&id=1af1ce18&scoped=true"
import script from "./HsabBiometricAuthSetup.vue?vue&type=script&lang=ts"
export * from "./HsabBiometricAuthSetup.vue?vue&type=script&lang=ts"
import style0 from "./HsabBiometricAuthSetup.vue?vue&type=style&index=0&id=1af1ce18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af1ce18",
  null
  
)

export default component.exports